import { render, staticRenderFns } from "./addPackVideo.vue?vue&type=template&id=a5802312&scoped=true&"
import script from "./addPackVideo.vue?vue&type=script&lang=js&"
export * from "./addPackVideo.vue?vue&type=script&lang=js&"
import style0 from "./addPackVideo.vue?vue&type=style&index=0&lang=less&"
import style1 from "./addPackVideo.vue?vue&type=style&index=1&id=a5802312&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5802312",
  null
  
)

component.options.__file = "addPackVideo.vue"
export default component.exports